import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { LogGroup, Size, CreateElement, Scale } from "../../../../MyHelpers";
import { ImageResource } from "../../../../ResourceManager/ImageResource";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { CanvasSprite } from "../../../Sprite/CanvasSprite";
import { GameTitleSlide } from "./GameTitleSlide";
import { Slide, SlideFactory2Params } from "./Slide";

export class GameTitleSlide1Screen extends GameTitleSlide {
	



    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize:Size) {
        super(initData, p , viewSize) ;
        this.viewSize = viewSize;
		this.logGroup = 	 this.p.logGroup.Add("GameTitleSlide1Screen");
		this.resid = 		 this.p.resid.Add("GameTitleSlide1Screen");
		this.systemContext = this.p.systemContext.CreateSubContext("GameTitleSlide1Screen");
        

        this.view = CreateElement("div", {
            classes: ["GameTitleSlide1Screen", this.resid.Scope()],
            style: {
                position: "absolute",
                height: Scale.Hpx(180),
                width: Scale.Wpx(900),
            }
        });
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //resourceManager.Add(new PixiSpriteResource(this.path + "title_sprite2", ResourceIdentifier.Global.Add(this.initData.Name + "titlegame").Add("GameTitleSlider"), true, this.logGroup.Add("GameTitleSlider"), true));
        resourceManager.Add(new ImageResource(this.path + "title.png", this.resid.ScopedResourceName("titleGame")));
    }

    public TitleGameImage : HTMLElement;

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.TitleGameImage = document.createElement("div");
		this.TitleGameImage.setAttribute("class", "TitleGameImage");
		this.TitleGameImage.classList.add(this.resid.ScopedResourceName("TitleGameImage"));
		this.TitleGameImage.style.position = "relative";
		//this.TitleGameImage.style.bottom = Scale.Ypx(0);
		//this.TitleGameImage.style.right = Scale.Xpx(0);
		this.TitleGameImage.style.width = "100%";
		this.TitleGameImage.style.height ="100%";
        this.TitleGameImage.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("titleGame")).CssBackground();
		this.TitleGameImage.style.backgroundPosition = "center";
		this.TitleGameImage.style.backgroundRepeat = "no-repeat";
		this.TitleGameImage.style.backgroundSize = "contain";
		this.view.appendChild(this.TitleGameImage);
    }
    public override View(): HTMLElement
	{
        return this.view;
	}
	
	public override Update()
	{
       
	}
	
	public override Start()
	{
        
    }

	public override Stop()
	{
      
    }
}
